<template>
  <div class="transportation-plan-bar">
    <div class="scroll-btn" @click="scrollPrev">
      <img :src="ossPath + '/pages/home/icon_left_999.png'" alt="" style="margin-right: 15px;">
      <div class="divider_line"></div>
    </div>
    <div class="scroll-container" ref="scrollContainer">
      <div class="plan-list" id="plan-list" :style="scrollStyle">
        <template v-for="(item, index) in list">
          <div class="plan-item"
               :key="item.id"
               @click="handleClick(item, index)"
               :class="{ 'plan-item_active': activeIndex === index }">
            {{ item.transportSchemeName }}
          </div>
          <div class="divider_line"></div>
        </template>
      </div>
    </div>
    <div class="scroll-btn" @click="scrollNext">
      <div class="divider_line"></div>
      <img :src="ossPath + '/pages/home/icon_right_999.png'" alt="" style="margin-left: 15px;">
    </div>
  </div>
</template>

<script>
export default {
  name: "transportationPlanBar",
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      offsetWidth: 0
    }
  },
  computed: {
    scrollStyle() {
      return `transform: translateX(${-this.offsetWidth}px);`
    }
  },
  watch: {
    list() {
      this.activeIndex = 0
      this.$nextTick(() => this.offsetWidth = 0)
    }
  },
  methods: {
    handleClick(item, index) {
      this.activeIndex = index
      this.$emit('change', item)
    },
    scrollPrev() {
      const containerWidth = this.$refs.scrollContainer.offsetWidth
      let currentOffset = this.offsetWidth
      let newOffset = currentOffset > containerWidth ?
                      currentOffset - containerWidth : 0
      this.offsetWidth = newOffset
    },
    scrollNext() {
      const navWidth = document.querySelector('.plan-list').offsetWidth
      const containerWidth = this.$refs.scrollContainer.offsetWidth
      console.log(navWidth, containerWidth)
      if (navWidth <= containerWidth) return
      let currentOffset = this.offsetWidth
      let newOffset = navWidth - currentOffset > containerWidth * 2
                      ? currentOffset + containerWidth
                      : (navWidth - containerWidth);
      console.log(newOffset)
      this.offsetWidth = newOffset
    }
  }
}
</script>

<style lang="scss" scoped>
.transportation-plan-bar {
  height: 60px;
  padding: 0 19px;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  background: #FFFFFF;
  flex-grow: 1;
  .scroll-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 10px;
      height: 17px;
    }
  }
  .divider_line {
    flex-shrink: 0;
    width: 1px;
    height: 40px;
    background: #EEEEEE;
  }
}
.scroll-container {
  width: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
  .plan-list {
    width: auto;
    float: left;
    display: flex;
    align-items: center;
    white-space: nowrap;
    transition: transform .3s cubic-bezier(.645, .045, .355, 1);
    .plan-item {
      min-width: 120px;
      height: 36px;
      margin: 0 16px;
      padding: 0 12px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 4px;
      flex-grow: 0;
      flex-shrink: 0;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
      transition: background-color .3s ease;
      &_active {
        background: #FF4D01;
        color: #FFFFFF;
      }
      &:hover {
        background: #FF4D01;
        color: #FFFFFF;
      }
    }
    .divider_line:last-child {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotPriceCompare/components/transportationPlanBar.vue